import { render, staticRenderFns } from "./DestroyVM.vue?vue&type=template&id=44688a16&scoped=true&"
import script from "./DestroyVM.vue?vue&type=script&lang=js&"
export * from "./DestroyVM.vue?vue&type=script&lang=js&"
import style0 from "./DestroyVM.vue?vue&type=style&index=0&id=44688a16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44688a16",
  null
  
)

export default component.exports